export enum SortDirection {
    None = 0,
    Ascending = 1,
    Descending = 2
}